import { render, staticRenderFns } from "./MatchDigitalStageStatistics.vue?vue&type=template&id=4ed579b8&scoped=true"
import script from "./MatchDigitalStageStatistics.vue?vue&type=script&lang=js"
export * from "./MatchDigitalStageStatistics.vue?vue&type=script&lang=js"
import style0 from "./MatchDigitalStageStatistics.vue?vue&type=style&index=0&id=4ed579b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed579b8",
  null
  
)

export default component.exports